import { render } from "./BaseFormField.vue?vue&type=template&id=c721e218&scoped=true"
import script from "./BaseFormField.vue?vue&type=script&lang=js"
export * from "./BaseFormField.vue?vue&type=script&lang=js"

import "./BaseFormField.vue?vue&type=style&index=0&id=c721e218&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c721e218"]])

export default __exports__